export default "<vl-checkbox [isChecked]=\"value\" [isDisabled]=\"isDisabled\" (checkedChange)=\"onCheckedChange($event)\"></vl-checkbox>\n";